export const REDIRECT_URL = 'redirect_url'
